import React from "react";
import { Reorder, useDragControls } from "framer-motion";
import { GripVertical } from "lucide-react";

/** One drag-reorderable section card in the resume editor. The grip handle is the only
 * drag trigger (`dragListener={false}` + `dragControls`) so clicking/typing inside the
 * section's own inputs never accidentally starts a drag. */
export default function DraggableSection({ sectionKey, label, children }) {
  const dragControls = useDragControls();

  return (
    <Reorder.Item
      value={sectionKey}
      dragListener={false}
      dragControls={dragControls}
      as="div"
      className="relative"
      data-testid={`resume-draggable-section-${sectionKey}`}
      whileDrag={{ scale: 1.01, boxShadow: "0 12px 32px rgba(0,0,0,0.35)", zIndex: 10 }}
    >
      <button
        type="button"
        onPointerDown={(e) => dragControls.start(e)}
        title={`Drag to reorder ${label}`}
        data-testid={`resume-drag-handle-${sectionKey}`}
        className="absolute -left-1 top-4 -translate-x-full pr-1.5 py-2 cursor-grab active:cursor-grabbing text-slate-500 hover:text-slate-300 hidden lg:flex touch-none"
      >
        <GripVertical className="w-4 h-4" />
      </button>
      {children}
    </Reorder.Item>
  );
}
